import React from 'react';

import styles from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <img className={styles.icon} src='/Asset/dealygo.png' alt='DealyGo' />
            <div className={styles.network}>
                <NavLink to='https://www.facebook.com/people/Dealygo-Amiens/pfbid0Vo3LZYRwyA1PqekMKK6pnXTZUP44W6CyuDhrxxA6suTPVewhKxW6st3GgqUqZEe7l/'><img className={styles.logo} src='/Footer/facebookIcon.png' alt='Facebook' /></NavLink>
                <NavLink to='https://www.instagram.com/dealygo/'><img className={styles.logo} src='/Footer/instagramIcon.png' alt='Instagram' /></NavLink>
                <NavLink to='https://www.tiktok.com/@dealygo'><img className={styles.logo} src='/Footer/tiktokIcon.png' alt='Tiktok' /></NavLink>
            </div>
            <nav className={styles.readme}>
                <li className={styles.article}>Politique de confidentialité</li>
                <li className={styles.article}>Nous contacter</li>
                <li className={styles.article}>CGV</li>
                <li className={styles.article}>CGU</li>
            </nav>
            <p className={styles.copyright}>Copyright © 2025 DealyGo</p>
        </footer>
    );
};

export default Footer;